// eslint-disable-next-line @typescript-eslint/no-require-imports
const loadTheme = require('../theme-loader');
const theme = loadTheme();
export default theme;
